import React from "react"
import { faCheck, faTimes, faInfo } from "@fortawesome/pro-solid-svg-icons"
import { StyledIcon, StyledIconWrapper } from "./styles"

export type ReviewIconBaseProps = React.HTMLAttributes<HTMLSpanElement> & {
  correct?: boolean
  groupMode?: boolean
}

export const ReviewIconBase = React.forwardRef<
  HTMLSpanElement,
  ReviewIconBaseProps
>(({ groupMode = false, correct, ...rest }, ref) => {
  if (groupMode) {
    return (
      <StyledIconWrapper ref={ref} groupMode={groupMode} tabIndex={0} {...rest}>
        <StyledIcon icon={faInfo} />
      </StyledIconWrapper>
    )
  }

  return (
    <StyledIconWrapper ref={ref} correct={correct} {...rest}>
      <StyledIcon icon={correct ? faCheck : faTimes} />
    </StyledIconWrapper>
  )
})
